import React, { useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import "./Sidebar.css";
import {
  FaHome,
  FaUserShield,
  FaUsersCog,
  FaUsers,
  FaUtensils,
  FaClipboardList,
  FaExchangeAlt,
  FaQuestionCircle,
  FaInfoCircle,
  FaBook,
  FaUserSlash,
  FaBell,
  FaSignOutAlt,
  FaChevronUp,
  FaImages,
} from "react-icons/fa";
import {
  about_icon,
  admin_icon,
  blocked_icon,
  CirclesFour,
  commision,
  dashboar_icon,
  faq_icon,
  food_icon,
  Grown,
  help_icon,
  logo,
  menu,
  notification_icon,
  order_icon,
  partner,
  pincode,
  role_icon,
  transaction_icon,
  unaccept,
  user_icon,
  videoIcon,
  walletSide,
  withdrawSide,
} from "../../assets/img/imgIndex";
import LogoutModal from "../LogoutModal/LogoutModal";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import Loader from "../Loader";
import usePermission from "../../customHook/usePermission";
import { FaChevronDown } from "react-icons/fa";

const Sidebar = ({ isViewed, setIsViewed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  let permission = usePermission();
  const [openMenu, setOpenMenu] = useState("");

  console.log("permission", permission);

  const handleLogoutConfirm = () => {
    post(URLS.LOGOUT)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);

          // updatePermission(res?.admin?.permissions);
          localStorage.clear();
          setShowLogoutModal(false);
          // navigate("/");
          setLoading(false);

          // localStorage.setItem("token", "123456789");
          // localStorage.setItem("userId", JSON.stringify(formData));
          // navigate("/dashboard");
          setTimeout(() => {
            navigate("/");
          }, 1500);
        } else {
          setLoading(false); // in case status isn't success
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
        // toast.error(err?.message);
      });
  };

  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };

  const menuItems = [
    {
      path: "/dashboard",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={dashboar_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Dashboard",
    },
    {
      path: "/admin",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={admin_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Admin",
      activeRoutes: ["/admin", "/add-admin"],
    },
    {
      path: "/roles",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={role_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Roles",
      activeRoutes: ["/roles", "/add-roles"],
    },
    {
      path: "/delivery-partner",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img src={partner} alt="" style={{ width: "100%", height: "100%" }} />
        </div>
      ),
      label: "Delivery Partner",
      activeRoutes: ["/delivery-partner", "/delivery-partner-view"],
    },
    {
      path: "/users",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={user_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Users",
      activeRoutes: ["/users", "/users-view"],
    },
    {
      path: "/foods",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={food_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Foods Management",
      activeRoutes: ["/foods", "/foods-view"],
    },
    {
      path: "/orders",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={order_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Order's Management",
      activeRoutes: ["/orders", "/orders-view"],
    },
    {
      path: "/subscription",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img src={Grown} alt="" style={{ width: "100%", height: "100%" }} />
        </div>
      ),
      label: "Subscription",
      activeRoutes: ["/subscription", "/subscription-view"],
    },
    // {
    //   path: "/transactions",
    //   icon: (
    //     <div style={{ width: 24, height: 24 }}>
    //       <img
    //         src={transaction_icon}
    //         alt=""
    //         style={{ width: "100%", height: "100%" }}
    //       />
    //     </div>
    //   ),
    //   label: "Transactions",
    // },
    {
      path: "/master",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={CirclesFour}
            alt=""
            style={{ width: "100%", height: "100%", marginTop: -4 }}
          />
        </div>
      ),

      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <span>Master</span>

          {openMenu === "/master" ? <FaChevronUp /> : <FaChevronDown />}
        </div>
      ),

      type: "submenu",

      children: [
        {
          path: "/master/kilometer-radius",
          label: "Kilometer Radius",
        },
        {
          path: "/master/food-availability-duration",
          label: "Food Availability Duration",
        },
        {
          path: "/master/config",
          label: "Config",
        },
        {
          path: "/master/delivery-pricing",
          label: "Delivery Pricing",
        },
      ],
    },
    {
      path: "/video",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={videoIcon}
            alt=""
            style={{ width: "100%", height: "100%", marginTop: -4 }}
          />
        </div>
      ),
      label: "Videos",
    },
    {
      path: "/promotion-banner",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <FaImages style={{ width: "100%", height: "100%" }} />
        </div>
      ),
      label: "Promotion Banner",
      activeRoutes: ["/promotion-banner", "/promotion-banner-add"],
    },
    {
      path: "/help",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={help_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Help & Support",
      activeRoutes: ["/help", "/help-edit"],
    },
    {
      path: "/delivery-help",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={help_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Delivery Partner Support",
      activeRoutes: ["/delivery-help", "/delivery-help-edit"],
    },
    {
      path: "/about",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={about_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "About Us",
      activeRoutes: ["/about", "/about-edit"],
    },
    {
      path: "/faq",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={faq_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "FAQ",
      activeRoutes: ["/faq", "/faq-edit"],
    },
    {
      path: "/blocked",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={blocked_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Blocked Seller",
      activeRoutes: ["/blocked", "/blocked-view"],
    },
    {
      path: "/pincode",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img src={pincode} alt="" style={{ width: "100%", height: "100%" }} />
        </div>
      ),
      label: "PinCode Management",
      activeRoutes: ["/pincode", "/pincode-view", "/pincode-user"],
    },
    {
      path: "/closed-requset",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={unaccept}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Unaccepted Request",
      activeRoutes: ["/closed-requset", "/closed-requset-view"],
    },
    {
      path: "/notifications",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={notification_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Push Notifications",
      activeRoutes: ["/notifications", "/notification-add"],
    },
    {
      path: "/delivery-notifications",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={notification_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Delivery Push Notifications",
      activeRoutes: ["/delivery-notifications", "/delivery-notification-add"],
    },
    {
      path: "/admin-commission",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={commision}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Admin Commission",
      activeRoutes: ["/admin-commission"],
    },
    {
      path: "/wallet-transaction",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={walletSide}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Wallet Transaction",
      activeRoutes: ["/wallet-transaction"],
    },
    {
      path: "/withdraw-request",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={withdrawSide}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Withdraw Request",
      activeRoutes: ["/withdraw-request"],
    },
    {
      path: "/inappUpdate",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={notification_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "In-App Update",
      activeRoutes: ["/inappUpdate", "/notification-add"],
    },
  ];

  const isMenuItemActive = (item) => {
    if (item.activeRoutes) {
      return item.activeRoutes.includes(location.pathname);
    }
    if (item.children) {
      return item.children.some((child) => location.pathname === child.path);
    }
    return location.pathname === item.path;
  };

  const [openSubMenu, setOpenSubMenu] = useState(false);

  const handleMasterClick = (e) => {
    e.preventDefault();
    setOpenMenu(openMenu === "/master" ? "" : "/master");
    setOpenSubMenu((prev) => !prev);
  };

  return (
    <div className={`sidebar ${isViewed ? "collapsed" : ""}`}>
      <div className="sidebar-logo">
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            overflow: "hidden",
          }}
        >
          <img src={logo} alt="" style={{ width: "100%", height: "100%" }} />
        </div>
        <div
          style={{ width: 32, height: 32, cursor: "pointer" }}
          onClick={() => setIsViewed(!isViewed)}
        >
          <img src={menu} alt="" style={{ width: "100%", height: "100%" }} />
        </div>
      </div>

      <nav className="sidebar-menu">
        {menuItems.map((item, index) => {
          switch (item.label) {
            case "Admin":
              if (!permission.includes("CAN-LIST-ADMIN_LIST")) {
                return null;
              }
              break;
            case "Roles":
              if (!permission.includes("CAN-LIST-ADMIN_ROLES")) {
                return null;
              }
              break;
            case "Users":
              if (!permission.includes("CAN-LIST-USERS")) {
                return null;
              }
              break;
            case "Foods Management":
              if (!permission.includes("CAN-LIST-FOODS_MANAGEMENT")) {
                return null;
              }
              break;
            case "Order's Management":
              if (!permission.includes("CAN-LIST-ORDERS_MANAGEMENT")) {
                return null;
              }
              break;
            case "Transactions":
              if (!permission.includes("CAN-LIST-TRANSACTION")) {
                return null;
              }
              break;
            case "Help & Support":
              if (!permission.includes("CAN-LIST-HELP_AND_SUPPORT")) {
                return null;
              }
              break;
            case "About Us":
              if (!permission.includes("CAN-LIST-ABOUT_US")) {
                return null;
              }
              break;
            case "FAQ":
              if (!permission.includes("CAN-LIST-FAQ")) {
                return null;
              }
              break;
            case "Blocked Seller":
              if (!permission.includes("CAN-LIST-BLOCKED_SELLER")) {
                return null;
              }
              break;

            case "Push Notifications":
              if (!permission.includes("CAN-LIST-PUSH_NOTIFICATION")) {
                return null;
              }
              break;

            case "Delivery Push Notifications":
              if (!permission.includes("CAN-LIST-PUSH_NOTIFICATION")) {
                return null;
              }
              break;
            case "Master":
              if (!permission.includes("CAN-LIST-MASTER")) {
                return null;
              }
              break;

            case "Videos":
              if (!permission.includes("CAN-LIST-VIDEOS")) {
                return null;
              }
              break;

            default:
              break;
          }
          if (item.type === "submenu") {
            return (
              <div key={index}>
                <a
                  href={item.path}
                  onClick={handleMasterClick}
                  className={
                    isMenuItemActive(item) ? "menu-item active" : "menu-item"
                  }
                >
                  <span className="menu-icon">{item.icon}</span>
                  {!isViewed && (
                    <span className="menu-label">{item.label}</span>
                  )}
                </a>

                {!isViewed && openSubMenu && (
                  <div className="submenu-list">
                    {item.children?.map((child) => (
                      <NavLink
                        key={child.path}
                        to={child.path}
                        className={
                          location.pathname === child.path
                            ? "submenu-item active"
                            : "submenu-item"
                        }
                      >
                        {child.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            );
          }

          return (
            <NavLink
              key={index}
              to={item.path}
              className={
                isMenuItemActive(item) ? "menu-item active" : "menu-item"
              }
            >
              <span className="menu-icon">{item.icon}</span>
              {!isViewed && <span className="menu-label">{item.label}</span>}
            </NavLink>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <button className="logout-btn" onClick={handleLogoutClick}>
          <FaSignOutAlt />
          {!isViewed && <span>Log Out</span>}
        </button>
      </div>

      <LogoutModal
        isOpen={showLogoutModal}
        onClose={handleLogoutCancel}
        onConfirm={handleLogoutConfirm}
      />
      {loading && <Loader />}
    </div>
  );
};

export default Sidebar;
